import {
	HiOutlineViewGrid,
	HiOutlineCube,
	HiOutlineUsers,
	HiOutlineAnnotation,
	HiOutlineQuestionMarkCircle,
	HiOutlineCog,
	HiOutlineVideoCamera,
	HiOutlineBookOpen,
	HiCurrencyDollar,
	HiOutlineTable,
	HiDocumentSearch,
	HiOutlineChartSquareBar,
	HiChartBar,
	HiOutlineTrendingUp         
} from 'react-icons/hi'
import { MdOutlinePayment } from "react-icons/md";
import { AiOutlineUser } from "react-icons/ai";

export const DASHBOARD_SIDEBAR_LINKS = [
	{
		key: 'dashboard',
		label: 'Dashboard',
		path: '/',
		icon: <HiOutlineViewGrid />
	},
	{
		key: 'staffs',
		label: 'Staffs',
		path: '/staffs',
		icon: <AiOutlineUser />
	},
	{
		key: 'students',
		label: 'Students',
		path: '/students',
		icon: <HiOutlineUsers />
	},
	{
		key: 'CourseManagement',
		label: 'Course',
		path: 'CourseManagement',
		icon: <HiOutlineBookOpen />
	},
	{
		key: 'classManagement',
		label: 'Class(Live)',
		path: '/classManagement',
		icon: <HiOutlineCube />
	},
	{
		key: 'videoClassManagement',
		label: 'Class(Video)',
		path: '/videoClassManagement',
		icon: <HiOutlineVideoCamera />
	},
	{
		key: 'quizManagement',
		label: 'Quiz',
		path: '/quizManagement',
		icon: <HiOutlineChartSquareBar  />
	},
	{
		key: 'payment',
		label: 'Payment',
		path: '/payment',
		icon: <MdOutlinePayment />
	},
	{
		key: 'messages',
		label: 'Messages',
		path: '/messages',
		icon: <HiOutlineAnnotation />
	},
	{
		key: 'token',
		label: 'Student Token',
		path: '/token',
		icon: <HiCurrencyDollar />
	},
	{
		key: 'timeTable',
		label: 'Timetable',
		path: '/timeTable',
		icon: <HiOutlineTable />
	},
	{
		key: 'transactionHistory',
		label: 'TransactionHistory',
		path: '/transactionHistory',
		icon: <HiDocumentSearch />
	},
	{
		key: 'statistics',
		label: 'Statistics',
		path: '/statistics',
		icon: <HiChartBar />
	},
	{
		key: 'performanceTracker',
		label: 'Performance Tracker',
		path: '/performanceTracker',
		icon: <HiOutlineTrendingUp />
	},
]

export const DASHBOARD_SIDEBAR_BOTTOM_LINKS = [
	{
		key: 'settings',
		label: 'Settings',
		path: '/settings',
		icon: <HiOutlineCog />
	},
	// {
	// 	key: 'support',
	// 	label: 'Help & Support',
	// 	path: '/support',
	// 	icon: <HiOutlineQuestionMarkCircle />
	// }
]